import { Auth0Provider, type AppState } from '@auth0/auth0-react';
import type { PropsWithChildren } from 'react';

import { useConfig } from './contexts/ConfigContext';

const canUseBrowserApis = typeof window !== 'undefined';

export const Auth0ProviderWithNavigate = ({ children }: PropsWithChildren) => {
  const appConfig = useConfig();

  const onRedirectCallback = (appState?: AppState) => {
    // After Auth0 redirects back, navigate to the returnTo path or the app root.
    // We use window.location.replace to avoid a full-page reload while also
    // not pushing the callback URL onto the history stack.
    window.location.replace(appState?.returnTo || '/veterans-case-mgmt');
  };

  if (!canUseBrowserApis) {
    return null;
  }

  return (
    <Auth0Provider
      domain={appConfig.auth.domain}
      clientId={appConfig.auth.clientId}
      cacheLocation="localstorage"
      authorizationParams={{
        redirect_uri: `${window.location.origin}${appConfig.auth.callbackPath}`,
        audience: appConfig.auth.audience,
        scope: 'openid profile email',
      }}
      onRedirectCallback={onRedirectCallback}
    >
      {children}
    </Auth0Provider>
  );
};
